module.exports = __webpack_public_path__ + "static/img/bruno-nascimento-PHIgYUGQPvU-unsplash_thumb.b04bafa.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/bruno-nascimento-PHIgYUGQPvU-unsplash_thumb.png
// module id = w/Lj
// module chunks = 4